import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { selectBooking } from '@selectors/booking.selector';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BBoxService } from '@services/bbox/bbox.service';
import { appNoOp } from '@actions/app.action';
import { trackConfirmedBooking } from '@actions/bbox.action';
import {
  selectIsBookPath,
  selectIsCancelPath,
  selectIsModifyPath,
  selectIsUpgradePath,
} from '@selectors/router.selector';

@Injectable()
export class BBoxEffect {
  trackConfirmedBooking$: Observable<Action> = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(trackConfirmedBooking),
        concatLatestFrom(() => [
          this.store.select(selectBooking),
          this.store.select(selectIsBookPath),
          this.store.select(selectIsModifyPath),
          this.store.select(selectIsUpgradePath),
          this.store.select(selectIsCancelPath),
        ]),
        filter(([, booking]) => !!booking),
        map(([, booking, isBookPath, isModifyPath, isUpgradePath, isCancelPath]) => {
          if (isBookPath) {
            this.bboxService.trackBooking(booking);
            if (booking) {
              this.bboxService.trackBookingSeats(booking);
            }
          } else if (isModifyPath) {
            this.bboxService.trackModifyBooking(booking);
          } else if (isUpgradePath) {
            this.bboxService.trackUpgradeBooking(booking);
          } else if (isCancelPath) {
            this.bboxService.trackCancelBooking(booking);
          }
          return appNoOp();
        }),
      );
    },
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private bboxService: BBoxService,
    private store: Store,
  ) {}
}
